import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Start from "./containers/Start";
import NotFound from './containers/NotFound';
import AppliedRoute from "./components/AppliedRoute";
import Main from "./containers/Main";
import Hiscore from './containers/Hiscore';


export default ({ childProps }) =>
    <Switch>
        <AppliedRoute path="/" exact component={Start} props={childProps}/>
        <AppliedRoute path="/main" exact component={Main} props={childProps}/>
        <AppliedRoute path="/score" exact component={Hiscore} props={childProps}/>
        {/* 404 page: */}
        <Route component={NotFound}/>
    </Switch>;

